import { useEffect, useState } from 'react';

// Wide screens show the conversation next to the list; narrow ones open it
// in a sheet over the list.
const QUERY = '(min-width: 1024px)';

export default function useWide() {
  const [wide, setWide] = useState(() => window.matchMedia?.(QUERY).matches ?? true);
  useEffect(() => {
    const media = window.matchMedia?.(QUERY);
    if (!media) return;
    const update = () => setWide(media.matches);
    media.addEventListener('change', update);
    return () => media.removeEventListener('change', update);
  }, []);
  return wide;
}
